import axios from 'axios';
import store from '@/store';

const API_LESSON_URL = `https://content-check-stag.elsanow.co/content_check_01_lesson`;
// const API_EXERCISE_URL = `https://content-check-stag.elsanow.co/content_check_01_exercise`; //`${config.API_ROOT}/exercise-check/`;
const API_EXERCISE_URL = `https://staging.elsanow.co/content2/api/i/ai/content-check`; //`${config.API_ROOT}/exercise-check/`;

export interface IContentCheckError {
  word: string;
  message: string;
  exercise_id: number;
  sentence: string;
  error_level: string;
}

export interface IContentCheckResponse {
  number_errors: number;
  number_warnings: number;
  result: IContentCheckError[];
}

export async function checkContent(
  jsonData: string,
  type: 'lesson' | 'exercise' = 'exercise'
) {
  try {
    const endpoint = type === 'lesson' ? API_LESSON_URL : API_EXERCISE_URL;
    const response = await axios.post<IContentCheckResponse>(
      endpoint,
      jsonData,
      {
        headers: {
          'Content-Type': 'application/json',
          'X-Session': store.state.sessionToken
        }
      }
    );

    return response.data;
  } catch (err) {
    return {
      number_errors: 1,
      number_warnings: 0,
      result: [
        {
          word: '',
          sentence: '',
          message: err.message,
          exercise_id: 0,
          error_level: 'ERROR'
        }
      ]
    };
  }
}
